var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatDotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59961 19.957L7.12357 18.7378L7.13478 18.7292C7.45249 18.475 7.61281 18.3468 7.79168 18.2554C7.95216 18.1734 8.12328 18.1137 8.2998 18.0775C8.49877 18.0366 8.70603 18.0366 9.12207 18.0366H17.8031C18.921 18.0366 19.4806 18.0366 19.908 17.8188C20.2843 17.6271 20.5905 17.3208 20.7822 16.9445C21 16.5171 21 15.9581 21 14.8402V7.23353C21 6.11562 21 5.55582 20.7822 5.12842C20.5905 4.75209 20.2837 4.44635 19.9074 4.25461C19.4796 4.03662 18.9203 4.03662 17.8002 4.03662H6.2002C5.08009 4.03662 4.51962 4.03662 4.0918 4.25461C3.71547 4.44635 3.40973 4.75209 3.21799 5.12842C3 5.55624 3 6.11671 3 7.23682V18.7078C3 19.7735 3 20.3063 3.21846 20.5799C3.40845 20.8179 3.69644 20.9564 4.00098 20.9561C4.35115 20.9557 4.76744 20.6227 5.59961 19.957Z",
    stroke: "#9B9FB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.0366C9 11.5889 8.55228 12.0366 8 12.0366C7.44772 12.0366 7 11.5889 7 11.0366C7 10.4843 7.44772 10.0366 8 10.0366C8.55228 10.0366 9 10.4843 9 11.0366Z",
    fill: "#9B9FB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.0366C13 11.5889 12.5523 12.0366 12 12.0366C11.4477 12.0366 11 11.5889 11 11.0366C11 10.4843 11.4477 10.0366 12 10.0366C12.5523 10.0366 13 10.4843 13 11.0366Z",
    fill: "#9B9FB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.0366C17 11.5889 16.5523 12.0366 16 12.0366C15.4477 12.0366 15 11.5889 15 11.0366C15 10.4843 15.4477 10.0366 16 10.0366C16.5523 10.0366 17 10.4843 17 11.0366Z",
    fill: "#9B9FB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDotsIcon);
export default __webpack_public_path__ + "static/media/ChatDotsIcon.9130bfbdc86d6203171fed6e6e76168a.svg";
export { ForwardRef as ReactComponent };